module.exports = __webpack_public_path__ + "img/heiltherme_thermenland_logo_134b3525.26dc5b65.svg";